var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467,
    height: 538,
    viewBox: "0 0 467 538",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.17896 241.366L11.2781 240.708C102.599 232.32 194.683 241.046 282.806 266.438V266.438",
    stroke: "url(#paint0_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30835 209.031H15.4075C107.133 208.861 198.085 225.814 283.597 259.019V259.019",
    stroke: "url(#paint1_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2791 177.197L22.3782 177.828C113.733 185.888 202.785 210.924 284.967 251.652V251.652",
    stroke: "url(#paint2_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1123 146.127L32.1063 147.39C122.414 163.6 208.907 196.524 287.149 244.471V244.471",
    stroke: "url(#paint3_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6577 116.054L44.5202 117.922C132.964 142.187 216.112 182.739 289.703 237.498V237.498",
    stroke: "url(#paint4_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8545 87.2197L59.5329 89.8507C145.446 121.946 224.626 169.787 293.015 230.921V230.921",
    stroke: "url(#paint5_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5737 59.8838L76.9892 63.0409C159.688 102.713 234.268 157.469 296.904 224.502V224.502",
    stroke: "url(#paint6_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6909 34.2314L96.7909 37.8621C175.598 84.7961 244.97 146.02 301.351 218.397V218.397",
    stroke: "url(#paint7_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.987 10.4229L118.745 14.5797C193.035 68.3941 256.647 135.596 306.319 212.742V212.742",
    stroke: "url(#paint8_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.333 -11.1514L142.592 -6.46829C211.766 53.7764 269.102 126.405 311.656 207.69V207.69",
    stroke: "url(#paint9_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.552 -30.5156L168.416 -25.3853C231.907 40.8294 282.501 118.311 317.603 203.085V203.085",
    stroke: "url(#paint10_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M191.364 -47.4602L195.807 -41.9089C253.108 29.7398 296.559 111.449 323.933 199.032V199.032",
    stroke: "url(#paint11_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M220.602 -61.8494L224.52 -55.9035C275.173 20.5952 311.125 105.874 330.534 195.561V195.561",
    stroke: "url(#paint12_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M250.998 -73.5579L254.363 -67.2962C297.962 13.4367 326.131 101.598 337.423 192.667",
    stroke: "url(#paint13_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M282.312 -82.4746L285.125 -75.9236C321.308 8.39484 341.468 98.7224 344.574 190.432V190.432",
    stroke: "url(#paint14_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M314.314 -88.554L316.522 -81.6609C345.013 5.5623 356.997 97.3373 351.86 188.957V188.957",
    stroke: "url(#paint15_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M346.733 -91.7378L348.31 -84.8184C368.878 4.61648 372.597 97.1053 359.274 187.904V187.904",
    stroke: "url(#paint16_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M379.305 -92L380.251 -84.9491C392.718 5.96539 388.134 98.4087 366.737 187.642V187.642",
    stroke: "url(#paint17_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M411.755 -89.3425L412.097 -82.239C416.365 9.42628 403.516 101.084 374.208 188.037V188.037",
    stroke: "url(#paint18_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M443.856 -83.7917L443.541 -76.6882C439.587 14.9707 418.578 105.087 381.594 189.036V189.036",
    stroke: "url(#paint19_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M475.331 -75.3728L474.385 -68.3219C462.221 22.6343 433.225 110.526 388.88 190.852V190.852",
    stroke: "url(#paint20_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M505.908 -64.165L504.33 -57.2457C484.08 32.259 447.325 117.2 395.95 193.219V193.219",
    stroke: "url(#paint21_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M535.358 -50.2744L533.176 -43.5129C504.982 43.8063 460.773 125.104 402.815 196.218V196.218",
    stroke: "url(#paint22_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M563.466 -33.7793L560.679 -27.2546C524.791 57.2023 473.475 134.22 409.363 199.848V199.848",
    stroke: "url(#paint23_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M589.966 -14.8604L586.6 -8.57241C543.287 72.3082 485.284 144.4 415.564 204.007V204.007",
    stroke: "url(#paint24_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M614.655 6.39697L610.763 12.3429C560.393 88.9944 496.195 155.588 421.453 208.716V208.716",
    stroke: "url(#paint25_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M637.376 29.7578L632.932 35.3354C575.884 107.182 505.939 167.747 426.69 213.923V213.923",
    stroke: "url(#paint26_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M657.88 55.1475L652.963 60.4093C589.706 126.852 514.617 180.904 431.55 219.791V219.791",
    stroke: "url(#paint27_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M676.051 82.1162L670.608 86.7203C601.651 147.212 522.024 194.304 435.811 225.581V225.581",
    stroke: "url(#paint28_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M691.648 110.689L685.89 114.898C611.789 168.959 528.267 208.725 439.603 232.159V232.159",
    stroke: "url(#paint29_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M704.788 140.574L698.688 144.231C620.042 191.432 533.292 223.551 442.883 238.945V238.945",
    stroke: "url(#paint30_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M715.071 171.46L708.682 174.565C626.122 214.527 536.838 238.733 445.409 245.942V245.942",
    stroke: "url(#paint31_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M722.59 203.191L715.938 205.822C630.126 238.207 539.035 254.311 447.328 253.31V253.31",
    stroke: "url(#paint32_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M727.219 235.448L720.383 237.342C632.015 261.914 539.843 269.783 448.592 260.547V260.547",
    stroke: "url(#paint33_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M728.956 267.992L721.962 269.281C631.75 285.811 539.249 285.374 449.197 267.992",
    stroke: "url(#paint34_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M727.742 300.562L720.669 301.22C629.346 309.586 537.265 300.852 449.141 275.463V275.463",
    stroke: "url(#paint35_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M723.645 332.895H716.546C624.82 333.066 533.868 316.113 448.356 282.907V282.907",
    stroke: "url(#paint36_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M716.648 364.731L709.575 364.1C618.265 356.003 529.262 330.959 447.118 290.25V290.25",
    stroke: "url(#paint37_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M706.839 395.802L699.845 394.539C609.533 378.331 523.037 345.398 444.802 297.431V297.431",
    stroke: "url(#paint38_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M694.276 425.873L687.413 423.978C598.971 399.722 515.822 359.18 442.23 304.429V304.429",
    stroke: "url(#paint39_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M679.104 454.708L672.426 452.077C586.518 419.97 507.34 372.131 438.943 311.006V311.006",
    stroke: "url(#paint40_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M661.38 482.043L654.965 478.964C572.266 439.293 497.686 384.536 435.05 317.504V317.504",
    stroke: "url(#paint41_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M641.269 507.669L635.169 504.012C556.363 457.087 486.991 395.872 430.609 323.503V323.503",
    stroke: "url(#paint42_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M618.941 531.348L613.183 527.165C538.902 473.358 475.299 406.165 425.634 329.029V329.029",
    stroke: "url(#paint43_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M594.599 553.078L589.341 548.395C520.175 488.139 462.849 415.502 420.303 334.211V334.211",
    stroke: "url(#paint44_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M568.408 572.443L563.491 567.181C499.994 500.962 449.399 423.47 414.304 338.684V338.684",
    stroke: "url(#paint45_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M540.587 589.386L536.143 583.966C478.842 512.318 435.391 430.608 408.017 343.025V343.025",
    stroke: "url(#paint46_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M511.352 603.752L507.434 597.832C456.776 521.337 420.823 436.056 401.421 346.367V346.367",
    stroke: "url(#paint47_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M480.958 615.539L477.592 609.277C433.977 528.523 405.808 440.332 394.532 349.235V349.235",
    stroke: "url(#paint48_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M449.747 624.405L446.934 617.854C410.751 533.535 390.591 443.208 387.485 351.498V351.498",
    stroke: "url(#paint49_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M417.64 630.482L415.432 623.72C386.928 536.491 374.943 444.705 380.094 353.076V353.076",
    stroke: "url(#paint50_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M385.229 633.666L383.625 626.72C363.065 537.292 359.356 444.812 372.687 354.023V354.023",
    stroke: "url(#paint51_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M352.651 633.954L351.678 626.903C339.22 535.987 343.812 443.544 365.219 354.312V354.312",
    stroke: "url(#paint52_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M320.197 631.323L319.855 624.219C315.572 532.538 328.412 440.862 357.717 353.891V353.891",
    stroke: "url(#paint53_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M288.093 625.72L288.408 618.616C292.362 526.957 313.37 436.841 350.355 352.892V352.892",
    stroke: "url(#paint54_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M256.629 617.301L257.576 610.25C269.726 519.291 298.724 431.397 343.081 351.077V351.077",
    stroke: "url(#paint55_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M226.045 606.092L227.622 599.146C247.872 509.65 284.628 424.718 336.002 348.708V348.708",
    stroke: "url(#paint56_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M196.599 592.201L198.782 585.413C226.96 498.095 271.17 416.803 329.143 345.708V345.708",
    stroke: "url(#paint57_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M168.413 575.705L171.2 569.154C207.098 484.718 258.414 407.719 322.517 342.104V342.104",
    stroke: "url(#paint58_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M142.118 556.762L145.484 550.501C188.804 469.625 246.806 397.534 316.52 337.921V337.921",
    stroke: "url(#paint59_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M117.271 535.532L121.083 529.586C171.44 452.923 235.64 386.327 310.393 333.213V333.213",
    stroke: "url(#paint60_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5813 512.169L98.9985 506.592C156.023 434.755 225.929 374.182 305.136 327.978V327.978",
    stroke: "url(#paint61_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0713 486.832L78.9618 481.571C142.217 415.125 217.306 361.073 300.376 322.188V322.188",
    stroke: "url(#paint62_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8979 459.785L61.1566 455.101C130.116 394.608 209.742 347.507 295.954 316.214V316.214",
    stroke: "url(#paint63_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2322 431.214L45.9904 427.03C120.085 372.96 203.609 333.193 292.277 309.77V309.77",
    stroke: "url(#paint64_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1914 401.353L33.2914 397.696C111.931 350.48 198.683 318.359 289.097 302.982V302.982",
    stroke: "url(#paint65_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8813 370.439L23.2706 367.335C105.835 327.39 195.117 303.193 286.543 295.984V295.984",
    stroke: "url(#paint66_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36377 338.737L16.0159 336.106C101.832 303.75 192.926 287.69 284.626 288.749V288.749",
    stroke: "url(#paint67_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7334 306.482L11.5696 304.562C99.9345 280.021 192.095 272.17 283.335 281.41V281.41",
    stroke: "url(#paint68_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M3 273.936L9.99395 272.647C100.196 256.103 192.69 256.54 282.732 273.936V273.936",
    stroke: "url(#paint69_linear_616_44674)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_616_44674",
    x1: 25.472,
    y1: 240.788,
    x2: 43.0579,
    y2: 317.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_616_44674",
    x1: 29.3462,
    y1: 214.528,
    x2: 77.8583,
    y2: 335.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_616_44674",
    x1: 35.8889,
    y1: 185.386,
    x2: 128.78,
    y2: 337.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_616_44674",
    x1: 45.1375,
    y1: 156.944,
    x2: 180.654,
    y2: 319.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_616_44674",
    x1: 56.9193,
    y1: 129.411,
    x2: 226.772,
    y2: 288.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_616_44674",
    x1: 71.2079,
    y1: 103.025,
    x2: 264.883,
    y2: 249.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_616_44674",
    x1: 87.8702,
    y1: 77.9898,
    x2: 294.636,
    y2: 206.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_616_44674",
    x1: 106.79,
    y1: 54.4875,
    x2: 317.26,
    y2: 163.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_616_44674",
    x1: 127.761,
    y1: 32.6756,
    x2: 334.04,
    y2: 121.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_616_44674",
    x1: 150.655,
    y1: 12.9186,
    x2: 346.005,
    y2: 83.1732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_616_44674",
    x1: 175.325,
    y1: -4.82224,
    x2: 354.41,
    y2: 48.4973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_616_44674",
    x1: 201.495,
    y1: -20.3489,
    x2: 359.928,
    y2: 18.1211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_616_44674",
    x1: 229.004,
    y1: -33.5372,
    x2: 363.141,
    y2: -7.67402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_616_44674",
    x1: 257.602,
    y1: -44.2763,
    x2: 364.678,
    y2: -28.5827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_616_44674",
    x1: 287.07,
    y1: -52.458,
    x2: 365.039,
    y2: -44.4271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_616_44674",
    x1: 317.271,
    y1: -58.031,
    x2: 366.061,
    y2: -54.9588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_616_44674",
    x1: 348.289,
    y1: -60.9804,
    x2: 374.034,
    y2: -60.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_616_44674",
    x1: 368.293,
    y1: -61.2426,
    x2: 394.035,
    y2: -60.3963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_616_44674",
    x1: 377.165,
    y1: -58.834,
    x2: 425.933,
    y2: -55.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_616_44674",
    x1: 386.352,
    y1: -53.7838,
    x2: 464.321,
    y2: -45.7506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_616_44674",
    x1: 395.486,
    y1: -46.0912,
    x2: 502.593,
    y2: -30.3883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_616_44674",
    x1: 404.354,
    y1: -35.8557,
    x2: 538.52,
    y2: -9.9782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_616_44674",
    x1: 412.944,
    y1: -23.1631,
    x2: 571.349,
    y2: 15.2926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_616_44674",
    x1: 421.139,
    y1: -8.08303,
    x2: 600.279,
    y2: 45.2649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_616_44674",
    x1: 428.892,
    y1: 9.21254,
    x2: 624.315,
    y2: 79.5168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_616_44674",
    x1: 436.218,
    y1: 28.6497,
    x2: 642.401,
    y2: 117.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_616_44674",
    x1: 442.791,
    y1: 50.0139,
    x2: 653.276,
    y2: 158.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_616_44674",
    x1: 448.846,
    y1: 73.2564,
    x2: 655.63,
    y2: 201.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_616_44674",
    x1: 454.17,
    y1: 97.8957,
    x2: 647.631,
    y2: 244.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_616_44674",
    x1: 458.865,
    y1: 124.049,
    x2: 628.751,
    y2: 283.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_616_44674",
    x1: 462.898,
    y1: 151.394,
    x2: 598.47,
    y2: 314.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_616_44674",
    x1: 466.017,
    y1: 179.653,
    x2: 558.96,
    y2: 331.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_616_44674",
    x1: 468.364,
    y1: 208.708,
    x2: 517.171,
    y2: 329.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_616_44674",
    x1: 469.885,
    y1: 238.621,
    x2: 487.502,
    y2: 315.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_616_44674",
    x1: 470.577,
    y1: 269.462,
    x2: 474.5,
    y2: 306.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_616_44674",
    x1: 470.432,
    y1: 278.634,
    x2: 488.034,
    y2: 355.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_616_44674",
    x1: 469.394,
    y1: 288.405,
    x2: 517.906,
    y2: 409.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_616_44674",
    x1: 467.715,
    y1: 298.442,
    x2: 560.679,
    y2: 450.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_616_44674",
    x1: 464.828,
    y1: 308.251,
    x2: 600.387,
    y2: 471.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_616_44674",
    x1: 461.492,
    y1: 317.786,
    x2: 631.344,
    y2: 476.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_616_44674",
    x1: 457.297,
    y1: 326.811,
    x2: 650.971,
    y2: 472.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_616_44674",
    x1: 452.346,
    y1: 335.601,
    x2: 659.057,
    y2: 463.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_616_44674",
    x1: 446.708,
    y1: 343.759,
    x2: 657.178,
    y2: 452.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_616_44674",
    x1: 440.407,
    y1: 351.282,
    x2: 646.667,
    y2: 440.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_616_44674",
    x1: 433.623,
    y1: 358.284,
    x2: 628.955,
    y2: 428.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_616_44674",
    x1: 426.081,
    y1: 364.395,
    x2: 605.237,
    y2: 417.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_616_44674",
    x1: 418.149,
    y1: 370.122,
    x2: 576.572,
    y2: 408.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_616_44674",
    x1: 409.822,
    y1: 374.676,
    x2: 543.958,
    y2: 400.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_616_44674",
    x1: 401.137,
    y1: 378.526,
    x2: 508.214,
    y2: 394.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_616_44674",
    x1: 392.243,
    y1: 381.514,
    x2: 470.212,
    y2: 389.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_616_44674",
    x1: 381.889,
    y1: 383.587,
    x2: 430.684,
    y2: 386.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_616_44674",
    x1: 366.411,
    y1: 384.781,
    x2: 392.169,
    y2: 385.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_616_44674",
    x1: 346.397,
    y1: 385.069,
    x2: 372.161,
    y2: 385.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_616_44674",
    x1: 322.005,
    y1: 384.405,
    x2: 370.748,
    y2: 387.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_616_44674",
    x1: 292.851,
    y1: 382.9,
    x2: 370.819,
    y2: 390.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_616_44674",
    x1: 263.236,
    y1: 380.358,
    x2: 370.343,
    y2: 396.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_616_44674",
    x1: 234.448,
    y1: 377.017,
    x2: 368.614,
    y2: 402.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_616_44674",
    x1: 206.728,
    y1: 372.82,
    x2: 365.134,
    y2: 411.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_616_44674",
    x1: 180.19,
    y1: 367.797,
    x2: 359.326,
    y2: 421.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_616_44674",
    x1: 155.446,
    y1: 361.991,
    x2: 350.864,
    y2: 432.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_616_44674",
    x1: 132.03,
    y1: 355.466,
    x2: 338.155,
    y2: 444.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_616_44674",
    x1: 110.672,
    y1: 348.237,
    x2: 321.094,
    y2: 456.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_616_44674",
    x1: 91.3657,
    y1: 340.297,
    x2: 298.139,
    y2: 468.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_616_44674",
    x1: 74.2433,
    y1: 332.005,
    x2: 267.766,
    y2: 478.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_616_44674",
    x1: 59.4938,
    y1: 323.127,
    x2: 229.346,
    y2: 482.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_616_44674",
    x1: 47.2065,
    y1: 313.802,
    x2: 182.778,
    y2: 476.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_616_44674",
    x1: 37.4892,
    y1: 304.173,
    x2: 130.384,
    y2: 456.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_616_44674",
    x1: 30.3996,
    y1: 294.203,
    x2: 78.995,
    y2: 414.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_616_44674",
    x1: 26.0244,
    y1: 280.826,
    x2: 43.6198,
    y2: 357.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_616_44674",
    x1: 24.3775,
    y1: 262.027,
    x2: 28.307,
    y2: 299.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle1);
export default __webpack_public_path__ + "static/media/Circle 1.0c7bf202aa338c352b7c5176a1b21018.svg";
export { ForwardRef as ReactComponent };